import React, { useState, useEffect } from 'react'
import { Button, Modal } from '@prima-afp/prima-ui-design-system/dist/ui-components';
import { useHistory } from 'react-router-dom/cjs/react-router-dom';
import { ButtonsContainer, ContainerContactData, ContainerHeader, ContainerTitleAMP } from './style';
import SimpleInput from '../../../components/PrimaInput/SimpleInput';
import Logo from '../../../../App/assets/images/logoPrimaOrange.svg'
import { useReCaptcha } from '../../../hooks/useRecaptcha';
import { FrameAuthorization } from '../../../componentes-sin-asesor/StepContactData/FrameAuthorization';
import { useDispatchDigitalTransfersContext, useStateDigitalTransfersContext } from '../../../context/DigitalTransfersContext';
import { saveLeads } from '../../../../digital-transfers/services';
import { useCatchFetch } from '../../../../digital-transfers/hooks/useCatchFetch';
import { sendToData } from '../../../../digital-transfers/constants'
import { MainContainer } from '../../../components/MainContainer';


export const LandingAMP = () => {
    const dispatch = useDispatchDigitalTransfersContext();
    const { urlFlow, userWeb } = useStateDigitalTransfersContext();
    const [dni, setDni] = useState('');
    const [phoneNumber, setPhoneNumber] = useState('');
    const [email, setEmail] = useState('');
    const [errorDocNumberInput, setErrorDocNumberInput] = useState(false);
    const [errorPhoneInput, setErrorPhoneInput] = useState(false);
    const [erroPhoneText, setErrorPhoneText] = useState('Por favor, ingrese un número de celular válido')
    const [errorEmailInput, setErrorEmailInput] = useState(false);
    const { executeReCaptcha, ReCaptchaComponent } = useReCaptcha();
    const [showModal, setShowModal] = useState(false);
    const history = useHistory();
    const { adpConfirmation } = userWeb;

    const { SendFetch, SetLoading } = useCatchFetch();

    useEffect(() => {
    }, []);



      useEffect(() => {
        const canonicalHref = `${process.env.REACT_APP_BASE_URL_TRASPASO}/traspasos/landing-amp`;
        if (!document.querySelector(`head link[href="${canonicalHref}"]`)) {
          const newLink = document.createElement("link");
          newLink.rel = "canonical";
          newLink.href = canonicalHref;
          document.head.appendChild(newLink);
        }
        const metaRobots = document.querySelector('meta[name="robots"]');
        if (!metaRobots) {
          const meta = document.createElement("meta");
          meta.name = "robots";
          meta.content = "noindex, nofollow";
          document.head.appendChild(meta);
        } else {
          metaRobots.setAttribute("content", "noindex, nofollow");
        }
      }, []);


    const onChangeDoc = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        setDni(value);
        if (value.length < 8) {
            setErrorDocNumberInput(true);
        } else {
            setErrorDocNumberInput(false);
        }
    };

    const onChangePhoneNumber = (e) => {
        const value = e.target.value.replace(/[^0-9]/g, "");
        setPhoneNumber(value);
        if (value.length < 9) {
            setErrorPhoneInput(true);
            setErrorPhoneText('Por favor, ingrese un número de celular válido')
        } else {
            setErrorPhoneInput(false);
        }
    };

    const onChangeMail = (e) => {
        const value = e.target.value;
        setEmail(value);
    };

    const isDisabled = () => {
        const emailRegex = /\S+@\S+\.\S+/;
        return !(
            dni.length == 8 &&
            phoneNumber.length == 9 &&            
            (email === null || email === '' || emailRegex.test(email))
        );
    };

    const Send = async () => {
        if (isDisabled() != true ){
        const recaptchaToken = await executeReCaptcha();
        SetLoading(true);
        const body = {
            documentNumber: dni,
            email,
            phoneNumber,
            recaptchaToken,
            tcConfirmation: true,
            adpConfirmation
        };

        const NoValid = ['999999999', '900000000','999999992','999888777','999888111','999887776', '999887766', '999999989', '999999998'];
        if (!phoneNumber || String(phoneNumber).charAt(0) !== "9" || String(phoneNumber).length !== 9 ||  NoValid.includes(String(phoneNumber))) {
            setErrorPhoneText('El número de celular no es válido');
            setErrorPhoneInput(true);
            SetLoading(false);

        }else{

            SendFetch(saveLeads(body))
            .then((res) => {
                if (res.code === 0) {
                    var payload = {
                        section: "landing amp",
                        option: "contactame",
                        dni: dni,
                        telefono: phoneNumber,
                        email: email,
                    };
                    sendToData(
                        window.location.href,
                        "step",
                        "paso_amp_1",
                        payload,
                        urlFlow
                    );
                    setShowModal(!showModal);
                    SetLoading(false);
                }
            })
            .catch((e) => {
                dispatch({
                    type: "NOT_VALID_DOCUMENT",
                    payload: {
                        idModal: "btn-error-documentIdentity",
                        content:
                            "Hubo un inconveniente con el registro de tu documento de identidad, por favor vuelve a intentarlo más tarde.",
                        changeLoading: false,
                        textButton: "Volver",
                        className: "centerContent",
                    },
                });
                var payload = {
                    section: "landing amp",
                    option: `hubo un inconveniente al registrar tu documento ${e.code}`,
                    dni: body.documentNumber,
                };
                sendToData(window.location.href, "step", "error", payload, urlFlow);
                SetLoading(false);
            });
        }
        }
    }

    const redirectToPublicZone = () => {
        var payload = {
            section: "landing amp - pop up",
            option: `Entiendo`,
        };
        sendToData(window.location.href, "step", "button_click", payload, urlFlow);
        window.location.href = 'https://www.prima.com.pe/traspasos/';
    }

    const redirectToDigitalTransfer = () => {
        var payload = {
            section: "landing amp - pop up",
            option: `Traspásate online`,
        };
        sendToData(window.location.href, "step", "button_click", payload, urlFlow);
        history.push('/pasos0');
    }

    return (
        <MainContainer>
            <ContainerHeader>
                <div>
                    <div
                        id="btn-identity-back"
                        style={{ flex: 1, display: "flex", textDecoration: "none" }}
                    >
                        <img
                            src={Logo}
                            alt="logo PRIMA"
                            className="primaLogoStep0"
                            style={{ cursor: "pointer" }}
                        />
                    </div>
                </div>
                <div className="text">Ayer. Hoy. Siempre</div>
            </ContainerHeader>
            <ReCaptchaComponent />
            <ContainerContactData>
                <ContainerTitleAMP>
                    <p className='title'>Nos contactaremos contigo</p>
                    <p className='subtitleAMP'>Estamos para asesorarte y acompañar tu decisión de traspaso. Ingresa los datos para contactarte.</p>
                </ContainerTitleAMP>
                <div id="idStep1ContainerInputs">
                    <div id="idWsrapperInputs" className="wrapperInputs" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '40px', marginTop: '64px', width: '633px', height: '84px' }}>
                        <SimpleInput inputName={'input_dni'} section={'landing-amp'} saveValueInput={onChangeDoc} type={'docNumber'} maxLength={8} value={dni} label={'Ingresa tu documento de identidad'} placeholder={'N° de documento'} flagError={errorDocNumberInput} errorMessage="Por favor, ingrese un DNI válido" haveIcon={false} textIcon={'DNI'} />
                        <SimpleInput inputName={'input_numero'} section={'landing-amp'} saveValueInput={onChangePhoneNumber} type={'phone'} maxLength={9} value={phoneNumber} label={'Ingresa tu número de celular'} placeholder={'Ejem. 980 998 099'} flagError={errorPhoneInput} errorMessage={erroPhoneText} haveIcon={false} textIcon={'+51'} showTooltipInput={false} tooltipMessage={'Coloca correctamente tu número'} />
                    </div>
                    <div className="wrapperInputs" style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '40px', width: '633px', height: '84px' }}>
                        <SimpleInput inputName={'input_email'} section={'landing-amp'} saveValueInput={onChangeMail} type={'mail'} value={email} label={'Ingresa tu correo electrónico'} placeholder={'Opcional'} flagError={errorEmailInput} errorMessage="El correo ingresado no es válido" haveIcon={true} />
                    </div>
                </div>
                <FrameAuthorization />
                <ButtonsContainer>
                    <Button
                        id="identity-btn-env-12"
                        className={`buttonStep1 newUiBtn ${isDisabled()
                            ? "disabledBtn"
                            : "enabledBtn"}`
                        }
                        onClick={Send}
                        disabled={isDisabled()}
                        size="large"
                        label="Contactarme"
                    />
                </ButtonsContainer>
            </ContainerContactData>
            <div id='WrapperModalID'>
                <Modal
                    id='ModalID'
                    className='ClassModal'
                    width='380px'
                    variant='promotional'
                    headerPromotionalImage={process.env.REACT_APP_ASSETS_URL + '/images/Formulario de venta asistida_Asesora virtual.svg'}
                    bodyTitle='Una de nuestras asesoras se comunicará contigo'
                    bodyText='Te llamaremos lo antes posible, o en caso no cumplas con las condiciones para el traspaso, te lo comunicaremos por correo.'
                    bodyAlign='center'
                    disableCloseOnOverlayClick={true}
                    footerButtons={{
                        primary: {
                            show: true,
                            label: 'Entendido',
                            onClick: () => {
                                redirectToPublicZone();
                            },
                        },
                        secondary: {
                            show: true,
                            label: 'Cámbiate online',
                            onClick: () => {
                                redirectToDigitalTransfer();
                            },
                        }
                    }}
                    showModal={showModal}
                    setShowModal={setShowModal}
                />
            </div>


        </MainContainer>
    );
}
